import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FoldDetailService} from '../../../../../services/apiServices/business/fold-detail.service';
import {TranslateService} from '@ngx-translate/core';
import {RowStatus} from '../../../../../model/row-status';
import {MessageService} from 'primeng/api';
import {HttpService} from '../../../../../services/apiServices/http-service.service';
import {AuthenticationService} from '../../../../../services/apiServices/security/authentication.service';
import {User} from '../../../../../model/user';
import {ActionConfirmKind} from '../../../../../model/action-confirm-kind';
import {CommonService} from '../../../../../services/apiServices/business/common.service';

/**
 * represent and handle the list of actions attached to a fold
 */
@Component({
  selector: 'app-multi-fold-action',
  templateUrl: './multi-fold-action.component.html',
  styleUrls: ['./multi-fold-action.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultiFoldActionComponent implements OnInit {

  /**
   * the fold for which the actions will be displayed and handled
   */
  @Input('folds') public folds: any[];
  public toProcess: any[];
  public enableExclude: boolean;
  public enableRestore: boolean;

  currentUser: User;

  public enableActions: boolean;
  /**
   * If the user click on visualization or exclude
   */
  public openMultiActionConfirmModal: boolean;

  /**
   * the user choice inside ActionConfirmKind
   */
  public userChoiceOfAction: number;

  constructor(private httpService: HttpService, private foldDetailService: FoldDetailService,
              private translate: TranslateService, private commonService: CommonService,
              private authService: AuthenticationService) {
  }

  /**
   * handle traduction, and column build
   */
  public ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.enableActions = this.currentUser.permissions.trackingDepot.withAction;
    this.openMultiActionConfirmModal = false;
    if (this.enableActions) {
      if (this.folds && this.folds.length > 0) {
        for (const fold of this.folds) {
          if (this.isFoldExcludable(fold)) {
            this.enableExclude = true;
          }
        }
        for (const fold of this.folds) {
          if (this.restoreEnabled(fold)) {
            this.enableRestore = true;
          }
        }
      }
    } else {
      this.enableExclude = false;
      this.enableRestore = false;
    }
  }

  /**
   * load Exclusion for a fold
   */
  public loadExclude(): void {
    this.toProcess = [];
    for (const fold of this.folds) {
      if (this.isFoldExcludable(fold)) {
        this.toProcess.push(fold);
      }
    }
    this.openMultiActionConfirmModal = true;
    this.userChoiceOfAction = ActionConfirmKind.EXCLUDE;
  }

  public loadRestore(): void {
    this.toProcess = [];
    for (const fold of this.folds) {
      if (this.restoreEnabled(fold)) {
        this.toProcess.push(fold);
      }
    }
    this.openMultiActionConfirmModal = true;
    this.userChoiceOfAction = ActionConfirmKind.RESTORE;
  }

  /**
   *
   * @param {boolean} result - the result of the event gave by action-confirm
   */
  public handleConfirmOrExcludeModalClose(result: boolean): void {
    this.openMultiActionConfirmModal = result;
  }

  /**
   * determine if the status of the fold is fail
   * @return {boolean}, the result of the comparison
   */
  public isFoldStatusFail(fold: any): boolean {
    if (!fold) {
      return false;
    }
    return (fold.rawStatus === RowStatus.FAILED || fold.rawStatus === RowStatus.FAILED_LEGACY);
  }
  /**
   * determine if the status of the fold is fail
   * @return {boolean}, the result of the comparison
   */
  public restoreEnabled(fold: any): boolean {
    if (!fold) {
      return false;
    }
    return this.isFoldStatusFail(fold)  || this.isFoldStatusDiscard(fold);
  }

  /**
   * determine if the status of the fold is success
   * @return {boolean}, the result of the comparison
   */
  public isFoldStatusSuccess(fold: any): boolean {
    if (!fold) {
      return false;
    }
    return (fold.rawStatus === RowStatus.PROCESSED && !fold.sFlowExchID);
  }
  /**
   * determine if the fold can be excluded when is has Success and not yet exported
   * @return {boolean}, the result of the comparison
   */
  public isFoldExcludable(fold): boolean {
    if (!fold) {
      return false;
    }
    if (!fold.erlId) {
      return (this.isFoldStatusSuccess(fold));
    }
    else {
      return (fold.status === 'LRE_CREATED' || fold.status === 'LRE_PLANNED');
    }
  }

  /**
   * determine if the status of the fold is discard
   * @return {boolean}, the result of the comparison
   */
  public isFoldStatusDiscard(fold: any): boolean {
    if (!fold) {
      return false;
    }
    return (fold.rawStatus === RowStatus.DISCARDED || fold.rawStatus === RowStatus.DISCARDED_LEGACY);
  }
}
